module.exports = __webpack_public_path__ + "img/seldak.79a9bce0.png";